import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import axios from "axios";
import { Alert, Form, Input, Modal, Spin } from "antd";
import { axiosErrorHandler, isConcurrentModificationError } from "../../../../swzutils";
const DeallocateVehicleModal = (props) => {
    const [form] = Form.useForm();
    const [stateLoading, setStateLoading] = useState(false);
    const [stateErrorMessage, setStateErrorMessage] = useState(null);
    useEffect(() => {
        if (!props.open) {
            // If we are being hidden clear error message for next use
            setStateErrorMessage(null);
            form.resetFields();
        }
    }, [props.open]);
    const onFinish = (formValues) => {
        deallocateFromVehicle(formValues.reason);
    };
    const deallocateFromVehicle = (reason) => {
        setStateLoading(true);
        axios(`/admin/v1/vehicle-hires/${props.vehicleHireId}/deallocate?version=${props.vehicleHireVersion}`, {
            method: "put",
            data: {
                reason: reason,
                vehicleId: props.allocatedVehicleId
            }
        }).then(response => {
            if (props.onDeallocated && response.data) {
                props.onDeallocated(response.data);
            }
        }).catch((error) => {
            if (isConcurrentModificationError(error)) {
                setStateErrorMessage("The vehicle deallocation could not be performed. This is because another user has modified the same vehicle request.  Please refresh the list and try again.");
            }
            else {
                axiosErrorHandler(error, (errorMessage) => setStateErrorMessage(errorMessage));
            }
        }).finally(() => {
            setStateLoading(false);
        });
    };
    return (_jsx(Modal, { title: "Deallocate request from vehicle", open: props.open, onOk: form.submit, onCancel: props.onCancel, confirmLoading: stateLoading, children: _jsxs(Spin, { spinning: stateLoading, children: [_jsx(Form, { layout: "horizontal", form: form, onFinish: onFinish, children: _jsx(Form.Item, { name: "reason", label: "Reason", rules: [
                            { required: true, message: 'A reason is required' },
                            { max: 500, message: 'Please limit to 500 characters.' }
                        ], children: _jsx(Input.TextArea, { placeholder: "Reason", rows: 2 }) }) }), stateErrorMessage ?
                    _jsx(Alert, { description: stateErrorMessage, type: "error", showIcon: true }) : null] }) }));
};
export default DeallocateVehicleModal;
